import { ShowcaseFormat } from '../domain/types/showcaseTypes';

export const showcaseFormatLabels: Record<ShowcaseFormat, string> = {
  A4: 'Pagina A4',
  A3: 'Pagina A3',
  _16_9: 'Schermo 16:9',
};
